import { Image, List } from '@yleisradio/areena-types';
import React, { useId } from 'react';
import { ChannelHeader } from '../ChannelHeader/ChannelHeader';
import { ChannelPrograms } from '../ChannelPrograms';
import styles from './Channel.module.scss';
import { SummaryViewEventParams } from 'services/snowplowAnalytics/contextGenerators';

interface ChannelProps {
  isFutureDate: boolean;
  isToday: boolean;
  channelContent: List;
  title: string | undefined;
  image: Image | undefined;
  channelHeader?: (headingID: string) => React.ReactNode;
  showExpired: boolean;
  currentTime: number;
  sendSummaryViewEvent: (params: SummaryViewEventParams) => void;
}

export const Channel = ({
  isFutureDate,
  isToday,
  channelContent,
  title = '',
  image,
  channelHeader,
  showExpired,
  currentTime,
  sendSummaryViewEvent,
}: ChannelProps) => {
  const headingId = useId();

  return (
    <section className={styles.channelRoot} aria-labelledby={headingId}>
      {channelHeader ? (
        channelHeader(headingId)
      ) : (
        <ChannelHeader headingId={headingId} image={image} title={title} />
      )}

      <ChannelPrograms
        source={channelContent.source}
        isFutureDate={isFutureDate}
        isToday={isToday}
        showExpired={showExpired}
        currentTime={currentTime}
        sendSummaryViewEvent={sendSummaryViewEvent}
      />
    </section>
  );
};
